"use client";

import React from "react";
import styles from "./bless-updates.module.scss";
import Slides from "@/components/layout/slides/slides";

const BlessUpdates = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.header}>Bless updates</div>
        <div className={styles.subText}>The latest news coverage, podcast episodes, upcoming events, and more.</div>
        <Slides />
      </div>
      {/* <UpdatesSlider /> */}
    </div>
  );
};

export default BlessUpdates;
